import Intro from "../Components/Intro";
import Layout from "../Components/Layout";

function MainPage() {
    return (
        <Layout>
            <Intro />
        </Layout>
    )
}

export default MainPage;